import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const getBottomData = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PLANNING_BOTTOM.GET_DATA}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const postSaveData = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PLANNING_BOTTOM.SAVE_DATA}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addChannel = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PLANNING_BOTTOM.ADD_CHANNEL}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getChannelList = async (data) => {
  try {
    let isActive = '';
    if (data) {
      isActive = 'isActive=true';
    }

    return await apiClient.get(`${apiEndpoint}${API.PLANNING_BOTTOM.GET_CHANNEL}?${isActive}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editChannel = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PLANNING_BOTTOM.EDIT_CHANNEL}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setChannelSequence = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PLANNING_BOTTOM.SET_SEQUENCE}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export const deleteChannelService = async (deleteIds) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.PLANNING_BOTTOM.DELETE_CHANNEL}`, { params: deleteIds });
  } catch (error) {
    console.log(error);

    throw error;
  }
};
